//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LinsesTitle',

  props: {
    title: {
      type: String,
      default: '',
    },

    isCompetitors: {
      type: Boolean,
      default: false,
    },
    isNeedLogo: {
      type: Boolean,
      default: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  }
}
